import {
  CreateTrustedSourceDto,
  TrustedSourceDto,
  TrustedSourceFeatureDto,
} from '@user1st/api-client';
import { trimRequestData } from '@/shared/utils';
import { TrustedSourceFields } from '@/shared/components/Forms/TrustedSourceForms/TrustedSourceForm.consts';

export const setTrustedSourcePayload = (values: any): CreateTrustedSourceDto => {
  const { type, value, features, featuresLimits, expiredAt, comment } =
    trimRequestData<TrustedSourceFields>(values);

  return {
    type,
    value,
    features: features?.map((feature) => ({
      code: feature,
      monthlyLimitPrice: Number(featuresLimits[feature].monthlyLimitPrice) || undefined,
      monthlyLimitRequests: Number(featuresLimits[feature].monthlyLimitRequests) || undefined,
    })),
    expiredAt,
    comment,
  };
};

export const setTrustedSourceFormValues = (data: TrustedSourceDto) => {
  return {
    type: data.type,
    value: data.value,
    features: data.features?.map((feature) => feature.code),
    featuresLimits: data.features?.reduce(
      (acc: Record<string, TrustedSourceFeatureDto>, feature) => {
        acc[feature.code] = feature;
        return acc;
      },
      {}
    ),
    expiredAt: data.expiredAt,
    comment: data.comment,
  };
};
